import { createContext, useContext, useState, type ReactNode } from 'react'
import type { Currency } from './money'

interface Ctx {
  currency: Currency
  setCurrency: (c: Currency) => void
}

const CurrencyContext = createContext<Ctx>({ currency: 'USD', setCurrency: () => {} })

export function CurrencyProvider({ children }: { children: ReactNode }) {
  const [currency, setCurrency] = useState<Currency>('USD')
  return <CurrencyContext.Provider value={{ currency, setCurrency }}>{children}</CurrencyContext.Provider>
}

export const useCurrency = () => useContext(CurrencyContext)
